import { H2, H4 } from '@base'
import { Spacings, Text } from '@styles'
import React from 'react'
import styled from 'styled-components'

const CardContainer = styled.div`
	display: flex;
	padding: ${Spacings.SPACING_6B};
	flex-direction: column;
	align-items: flex-start;
	gap: 0.875rem;
	flex: 1 0 0;
	border-radius: ${Spacings.SPACING_4B};
	border: 1px solid var(--Cool-Gray-20, ${({ theme }) => theme.palette.text.greyFive});
	background: var(--Base-White, ${({ theme }) => theme.palette.background.white});

	/* shadey */
	box-shadow: 0 0 26px 0 rgba(110, 110, 110, 0.1);
`
const ImageWapper = styled.div`
	display: flex;
	padding: ${Spacings.SPACING_2B};
	align-items: center;
	gap: ${Spacings.SPACING_2B};
	border-radius: ${Spacings.SPACING_2B};
	border: 1px solid var(--Cool-Gray-20, ${({ theme }) => theme.palette.text.greyFive});
`
const LabelContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	align-self: stretch;
`
const LabelWapper = styled(H4)`
	color: var(--Cool-Gray-60, ${({ theme }) => theme.palette.text.greyThree});
	font-family: Poppins;
	font-style: normal;
	font-weight: ${Text.BOLD_500};
	line-height: ${Spacings.SPACING_6B}; /* 150% */
`
const ValueWapper = styled(H2)`
	color: var(--Cool-Gray-60, ${({ theme }) => theme.palette.text.greyThree});
	font-family: Poppins;
	font-style: normal;
	font-weight: ${Text.BOLD_500};
	line-height: ${Spacings.SPACING_7B}; /* 140% */
`
const Cards = ({ icon, label, value, unit }) => {
	return (
		<CardContainer>
			<ImageWapper>
				<img src={icon} alt={'-'} />
			</ImageWapper>
			<LabelContainer>
				<LabelWapper>{label}</LabelWapper>
				<ValueWapper>
					{value} {unit}
				</ValueWapper>
			</LabelContainer>
		</CardContainer>
	)
}

export default Cards
